export const config = {
  NETLIFY_SITE_ID: "submit-addon.netlify.com",
}